import { connect } from 'react-redux';
import SelectBucket from './SelectBucket';
import { has } from 'lodash';
import { getCurrentOrg } from 'js/reducers/session';

const mapStateToProps = (state, ownProps) => {
  const { probe, request } = state;
  const { selectedCredentialId } = ownProps;
  let isLoadingProbeData = !!request.PROBE_GET_TREE_REQUEST;
  let probeError = null;
  let probeData = null;
  let probeTreeLastUpdatedAt = null;
  if (selectedCredentialId && has(probe, selectedCredentialId)) {
    const probeResponse = probe[selectedCredentialId];
    probeError = probeResponse.error;

    if (probeResponse.nestedProbeTree) {
      probeData = probeResponse.nestedProbeTree;
    }
    probeTreeLastUpdatedAt = probeResponse.treeLastUpdatedAt;
  }

  return {
    currentOrg: getCurrentOrg(state),
    probeError,
    probeData,
    probeTreeLastUpdatedAt,
    isLoadingProbeData,
  };
};

export default connect(mapStateToProps, {})(SelectBucket);
